/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope } from 'angular';
import { UsersService } from '../../../shared/users/users.service';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';
import { OpportunityModel } from '../../../src/app/shared/models/opportunity/opportunity';
import { OpportunityRequest, OpportunityUserNote } from '../../../src/app/@shared-types/opportunites';
import { EOpportunityInfoType } from '../../../src/app/@shared-types/opportunites/enums';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';

interface AvailabilityScope extends IScope {
  vehicle: AutoboardVehicle,
  customerId?: string,
  exit: (data: VehicleFormComponentExitFunction) => void,
}

/* @ngInject */
export default class OpportunityFormController {
  private exit: (data: VehicleFormComponentExitFunction) => void;

  public sending = false;

  private vehicle!: AutoboardVehicle;

  private $scope: AvailabilityScope;

  private opportunityModel: OpportunityModel;

  private toastService: ToastService;

  private formData: {
    userId: string,
    comment: string | null,
    customerId: string | null,
  };

  /** Selectable list of users for admins only. */
  public userFilter: { [key: string]: string } | null = null;

  constructor(
    $scope: AvailabilityScope,
    usersService: UsersService,
    opportunityModel: OpportunityModel,
    toastService: ToastService,
  ) {
    this.opportunityModel = opportunityModel;
    this.toastService = toastService;
    this.$scope = $scope;

    this.formData = {
      userId: '',
      comment: null,
      customerId: null,
    };

    this.vehicle = this.$scope.vehicle;
    this.exit = this.$scope.exit;

    const userFilter: { [key: string]: string } = {};
    usersService.getUsers()
      .forEach((u) => {
        userFilter[u.id] = `${u.first_name} ${u.last_name}`;
      });
    this.userFilter = userFilter;
  }

  public exitForm = (): void => {
    this.exit({ removeLock: true });
  };

  public formTransmission = async (): Promise<void> => {
    this.sending = true;

    if (!this.formData.userId
      || !this.formData.comment
      || !this.formData.customerId) {
      this.sending = false;
      return;
    }

    const userId = parseInt(this.formData.userId, 10);

    try {
      const opportunityRequest: OpportunityRequest = {
        customerId: this.formData.customerId,
        userId,
        vehicleId: String(this.vehicle._id),
        dummyVehicle: false,
      };
      const res = await this.opportunityModel.post(opportunityRequest);

      // Add Note Info to Opportunity
      const info: OpportunityUserNote = {
        message: this.formData.comment,
      };
      await this.opportunityModel.postInfo({
        data: info,
        opportunityId: res.id,
        type: EOpportunityInfoType.NOTE,
      });

      const redirectUrl = `/opportunities/opportunity/${res.id}`;

      this.exit({ removeLock: true, redirect: redirectUrl });
    } catch (e) {
      this.sending = false;
      this.toastService.toast(ToastType.ERROR, 'Fehler bei der Erstellung der Verkaufschance.');
    }
  };
}
